// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const GET_FOOD_MEALS_REQUESTS_SUCCESS = 'GET_FOOD_MEALS_REQUESTS_SUCCESS';
const GET_FOOD_MEAL_REQUESTS_SUCCESS = 'GET_FOOD_MEAL_REQUESTS_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestFoodMealsSuccess(payload) {
  return {
    type: GET_FOOD_MEALS_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestFoodMealSuccess(payload) {
  return {
    type: GET_FOOD_MEAL_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestFoodMeals(params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/feeding/meals`, {params})
      .then((r) => {
        dispatch(_getRequestFoodMealsSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}/**
 * @param {number} FoodMealsId
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestFoodMeal(foodMealId, params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/feeding/meals/${foodMealId}`, {params})
      .then((r) => {
        dispatch(_getRequestFoodMealSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}

/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestFoodMeals() {
  return _getRequestFoodMealsSuccess({data: {foodMeals: []}, meta: {}});
}
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestFoodMeal() {
  return _getRequestFoodMealSuccess({data: {foodMeal: {}}, meta: {}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(state = {
  foodMeals: [],
  foodMeal: {},
}, action) {
  switch (action.type) {
    case GET_FOOD_MEALS_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        foodMeals: action.payload.meals,
      });
    case GET_FOOD_MEAL_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        foodMeal: action.payload.meal,
      });
    default:
      return state;
  }
}
